import { useState, useEffect } from "react";

import { Card, CardBody, Col, Label, Row } from "reactstrap";

//Unform e componentes
import ModalTabela from "@/frontend/componentes/ModalTabela";
import TooltipItem from "@/frontend/componentes/TooltipItem";

//Common
import { ID_AUTORIZACAO, SITUACAO_SOLICITACAO } from "@/common/constantes";
import { fn_formatarDataHora } from "@/common/utils/date";
import {
  fn_getLabelCentroCusto,
  fn_getLabelFornecedor,
  fn_getTipoApropriacao,
} from "@/common/siig";

//Util
import { ICONES_BOTAO, ICONES_SIIG } from "@/frontend/utils/icones";
import {
  fn_getJsxCampoTipoSolicitacao,
  fn_getJsxSituacaoSolicitacao,
  fn_loadApresentacaoSelecaoCentros,
} from "@/frontend/utils/siig/solicitacao";

//API
import { api_getUltimoLogAutorizacao } from "@/frontend/services/api/api_others";
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";

//Telas
import CardLogAutorizacao from "../../../../acesso/autorizacao/card_log_autorizacao";

function TSolicitacao_det_aba_ident({ solicitacao }) {
  //### USE STATE ###
  const [modalOpenCentros, setModalOpenCentros] = useState(false);

  const [logCancelamento, setLogCancelamento] = useState(null);
  const [correcoes, setCorrecoes] = useState([]);
  const [corrigiuCentros, setCorrigiuCentros] = useState(false);
  const [corrigiuContas, setCorrigiuContas] = useState(false);

  const [centrosTodos, setCentrosTodos] = useState([]);
  const [centrosIndividual, setCentrosIndividual] = useState([]);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Carrega os logs de correção da solicitação
    async function loadLogsCorrecao() {
      const correcoes = await api_listar(
        ROTA_LISTAR.SOLICITACAO_CORRECAO,
        `id_solicitacao=${solicitacao.id}`,
      );

      const logs = correcoes.flatMap((correcao) => correcao.logs);

      setCorrecoes(correcoes);
      setCorrigiuContas(logs.some((log) => log.campo == "contas"));
      setCorrigiuCentros(logs.some((log) => log.campo == "centros"));
    }

    //Monta as opções que foram selecionadas no centro de custo na criação da solicitação
    function montarSelecaoCentros() {
      const { centrosTodos, centrosIndividuais } =
        fn_loadApresentacaoSelecaoCentros(solicitacao.centros);
      setCentrosTodos(centrosTodos);
      setCentrosIndividual(centrosIndividuais);
    }

    if (solicitacao.situacao == SITUACAO_SOLICITACAO.CANCELADA) {
      //Carrega os dados do log de autorização do cancelamento
      async function loadLogCancelamentoSolicitacao() {
        const log = await api_getUltimoLogAutorizacao(
          ID_AUTORIZACAO.CANCELAMENTO_SOLICITACAO,
          "Solicitacao",
          solicitacao.id,
        );
        setLogCancelamento(log);
      }
      loadLogCancelamentoSolicitacao();
    }

    loadLogsCorrecao();
    montarSelecaoCentros();
  }, []);

  //### EVENTOS ###
  function handleBotaoCentros() {
    setModalOpenCentros(true);
  }

  return (
    <div className="m-1">
      <div>
        <br />

        <Card>
          <CardBody>
            <div className="custom-card-title  mb-0">
              {ICONES_SIIG.IDENTIFICACAO} Identificação
            </div>

            <Row>
              <Col>
                <div className="d-flex align-items-center justify-content-end">
                  <Label className="fw-bold mb-0 me-2">Situação:</Label>

                  {fn_getJsxSituacaoSolicitacao(solicitacao.situacao)}
                </div>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold mb-0">Tipo:</Label>
              </Col>
              <Col>
                <div className="d-flex">
                  {fn_getJsxCampoTipoSolicitacao(solicitacao.tipo)}
                </div>
              </Col>
            </Row>

            <Row className="mb-2">
              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold mb-0">Número:</Label>
              </Col>
              <Col className="fw-bold">{solicitacao.numero}</Col>
            </Row>

            <Row>
              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold">Data:</Label>
              </Col>
              <Col>{fn_formatarDataHora(solicitacao.data)}</Col>

              <Col sm="5" md="6" lg="6">
                <div className="d-flex align-items-center">
                  <div className="me-4">
                    <Label className="fw-bold me-2">Operação realizada:</Label>
                    {solicitacao.operacao_realizada == "S" ? "Sim" : "Não"}
                  </div>
                  <div className="me-4">
                    <Label className="fw-bold me-2">Necessita aprovação:</Label>
                    {solicitacao.exige_aprovacao == "S" ? "Sim" : "Não"}
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold">Descrição:</Label>
              </Col>
              <Col>{solicitacao.descricao}</Col>
            </Row>

            <Row>
              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold">Motivo:</Label>
              </Col>
              <Col>{solicitacao.motivo}</Col>
            </Row>

            <Row>
              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold">Empresa:</Label>
              </Col>
              <Col>{solicitacao.empresa.nome}</Col>

              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold">Fornecedor:</Label>
              </Col>
              <Col>{fn_getLabelFornecedor(solicitacao.fornecedor)}</Col>
            </Row>

            <Row>
              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold">
                  Contas:
                  {corrigiuContas && (
                    <TooltipItem
                      text="Houve correção de conta"
                      showImageAviso
                    />
                  )}
                </Label>
              </Col>

              <Col>
                {solicitacao.contas
                  .map((solConta) => solConta.conta.nome)
                  .join(", ")}
              </Col>

              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold">Apropriação:</Label>
              </Col>
              <Col>
                {fn_getTipoApropriacao(solicitacao.tipo_apropriacao)?.label}
              </Col>
            </Row>

            <Row>
              <Col sm="2" md="1" lg="1">
                <Label className="fw-bold">
                  Centros:
                  <span>
                    {corrigiuCentros && (
                      <TooltipItem
                        text="Houve correção de centro"
                        showImageAviso
                      />
                    )}
                  </span>
                </Label>
              </Col>

              <Col>
                {centrosTodos.map((c, index) => (
                  <div key={index}>{c}</div>
                ))}
                <div className="d-flex align-items-center">
                  {centrosIndividual.length <= 3
                    ? centrosIndividual
                        .map((centro) => fn_getLabelCentroCusto(centro))
                        .join(", ")
                    : `${centrosTodos.length > 0 ? "+" : ""} ${centrosIndividual.length} centros`}

                  {centrosIndividual.length > 3 && (
                    <span
                      onClick={handleBotaoCentros}
                      className="ms-2 btn-icone-sm"
                      title="Consultar"
                    >
                      {ICONES_BOTAO.VISUALIZAR}
                    </span>
                  )}
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <br />

        <Card>
          <CardBody>
            <div className="custom-card-title  mb-0">
              {ICONES_SIIG.RESPONSAVEIS} Responsáveis
            </div>

            <Row>
              <Col>
                <div className="d-flex align-items-center">
                  <div className="me-4">
                    <Label className="fw-bold me-2">Área:</Label>
                    {solicitacao.area.nome}
                  </div>
                  <div className="me-4">
                    <Label className="fw-bold me-2">Responsável:</Label>
                    {solicitacao.usuario_resp_area.nome}
                  </div>

                  <div className="me-4">
                    <Label className="fw-bold me-2">Negociador:</Label>
                    {solicitacao.nome_negociador || "Não informado"}
                  </div>

                  <div className="me-4">
                    <Label className="fw-bold me-2">Cadastrado por:</Label>
                    {solicitacao.usuario_cadastro.nome}
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <br />

        {logCancelamento && (
          <CardLogAutorizacao
            titulo="Cancelamento da solicitação"
            autorizacaoLog={logCancelamento}
          />
        )}
      </div>

      {/* MODAL TABELA */}
      {modalOpenCentros && (
        <ModalTabela
          modalOpen={modalOpenCentros}
          toggleModal={() => setModalOpenCentros(!modalOpenCentros)}
          titulo={"Centros de custo"}
          result={centrosIndividual}
          colunas={[
            { nome: "Código", campo: "codigo", align: "center", width: "10%" },
            { nome: "Nome", campo: "nome" },
          ]}
        />
      )}
    </div>
  );
}

export default TSolicitacao_det_aba_ident;
